import './PrizeDraw.css';
import RoulettePro from 'react-roulette-pro';
import NamePicker from '../components/NamePicker';
import axios from 'axios';
import JSConfetti from 'js-confetti';
import FullscreenComponent from '../components/FullScreen';
const { useState, useEffect } = require('react');
const { useParams } = require('react-router-dom');
const jsConfetti = new JSConfetti();

const PrizeDraw = () => {
	const [tickets, setTickets] = useState([]);

	const { mid } = useParams();

	useEffect(() => {
		const fetchTickets = async () => {
			try {
				const response = await axios.get(`/api/participants`, {
					params: {
						mid
					}
				});

				if (!response.data) {
					setTickets([]);
					return;
				}

				setTickets(
					response.data
						.filter((p) => {
							return (
								!p.user_name.includes('Otter') &&
								!p.user_name.includes('Notes') &&
								!p.user_name.includes('Notetaker') &&
								!p.user_name.includes('Record') &&
								!p.user_name.includes('@') &&
								!p.user_name.includes('+') &&
								/[A-Za-z]/.test(p.user_name) &&
								/^[A-Za-z]{3,}\s[A-Za-z]{3,}$/.test(p.user_name)
							);
						})
						.map((p) => {
							return {
								image: `https://ui-avatars.com/api/?size=170&rounded=true&background=random&name=${p.user_name
									.split(' ')
									.join('+')}`,
								text: toTitleCase(p.user_name),
								id:
									typeof crypto.randomUUID === 'function'
										? crypto.randomUUID()
										: generateId(),
								online:
									p.left &&
									new Date(p.left).getTime() >
										new Date(p.joined).getTime()
										? false
										: true
							};
						})
						.sort(() => Math.random() - 0.5)
				);
			} catch (err) {
				console.error(err);
			}
		};

		fetchTickets();
	}, []);

	const setWinner = () => {
		jsConfetti.addConfetti();
	};

	const generateId = () =>
		`${Date.now().toString(36)}-${Math.random().toString(36).substring(2)}`;

	function toTitleCase(str) {
		try {
			return str
				.toLowerCase()
				.split(' ')
				.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
				.join(' ');
		} catch (e) {
			return str;
		}
	}

	return (
		<>
			{tickets && tickets.length > 0 && (
				<div>
					<section className="top_banner">
						<div className="container">
							<div className="bnnertxtcntnt">
								<h4>
									<em>
										The KPI Members Event Tesla Model Y or
										40k Giveaway!
									</em>
								</h4>
								<h1>
									Who Will Have Their Life Changed by Winning
									a{' '}
									<span className="colr">Tesla Model Y</span>{' '}
									or <span className="colr">USD$40,000</span>?
								</h1>
							</div>
							<NamePicker
								participants={tickets}
								setWinner={setWinner}
							/>
						</div>
					</section>
					<center>
						<FullscreenComponent />
					</center>
				</div>
			)}
		</>
	);
};

export default PrizeDraw;
